import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import { formatPrice } from "@/js/currency/currencies.js";
export default {
  name: "WineCogsHistoryModal",
  props: {
    values: {
      type: Array
    }
  },
  data: function data() {
    return {
      shown: false,
      options: {
        color: "primary",
        zIndex: 2000
      },
      headers: [{
        text: "Date",
        value: "date",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "Cogs",
        value: "cogs",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "Comment",
        value: "comment",
        align: "left"
      }, {
        text: "User",
        value: "user",
        align: "center"
      }]
    };
  },
  created: function created() {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    open: function open() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this.shown = true;
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                _this.resolve = resolve;
                _this.reject = reject;
              }));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    cancel: function cancel() {
      this.shown = false;
      this.$emit("closed");
    },
    formatPrice: formatPrice
  }
};